import { render, staticRenderFns } from "./MediaMTX.vue?vue&type=template&id=dfcfe0ec&scoped=true&"
import script from "./MediaMTX.vue?vue&type=script&lang=js&"
export * from "./MediaMTX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcfe0ec",
  null
  
)

export default component.exports